import styled from 'styled-components';

export const FooterContainer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
  margin-top: auto;
`;

export const CopyrightText = styled.p`
  margin: 0;
  color: #6c757d;
  font-size: 0.9rem;
  text-align: center;
`;
